
import { defineComponent, onMounted, onBeforeUpdate } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import { SeminarAttributes } from '@/types/models/seminar'
import SeminarDetailsBody from '@/components/SeminarDetailsBody.vue'
import SeminarDetailsCompleted from '@/components/SeminarDetailsCompleted.vue'
import SeminarDetailsApply from '@/components/SeminarDetailsApply.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, SeminarDetailsBody, SeminarDetailsCompleted, SeminarDetailsApply, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const route = useRoute()

    const initialize = () => {
      axios
        .get<ApiResponse<SeminarAttributes>>(`/seminar/${route.params.seminar_id}`)
        .then(response => {
          store.commit('seminar/setSeminarDetails', response.data.payload)
        })
    }

    onBeforeUpdate(() => {
      initialize()
    })

    onMounted(() => {
      initialize()
    })

    return {
      t,
      store
    }
  },
})
